import styled from 'styled-components'

export const Container = styled.article`
  align-items: center;
  color: #fff;
  display: flex;
  /* display: none; */
  min-height: 45rem;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;

  .slide-in {
    opacity: 0;
    animation: slideInAnimation 0.5s ease forwards;
    /* Inicialmente, o elemento está fora da tela à esquerda */
    transform: translateX(-100%);
  }

  @keyframes slideInAnimation {
    from {
      /* Inicialmente, o elemento está fora da tela à esquerda */
      opacity: 0;
      transform: translateX(-100%);
    }
    to {
      /* No final da animação, o elemento está na posição original */
      opacity: 1;
      transform: translateX(0);
    }
  }

  .slide-in:nth-of-type(1) {
    animation-delay: 0.1s;
  }

  .slide-in:nth-of-type(2) {
    animation-delay: 0.2s;
  }

  .slide-in:nth-of-type(3) {
    animation-delay: 0.3s;
  }

  .slide-out {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  .slide-out.hide {
    opacity: 0;
    transform: translateY(100%);
  }

  @media only screen and (min-width: 1000px) {
  }
`
